import { Element, Node } from "@siteimprove/alfa-dom";
import { getOffsetParent } from "./get-offset-parent.js";
import { isPositioned } from "../predicate/is-positioned.js";
const { isElement } = Element;
/**
 * @public
 */
export function getPositioningParent(element, device) {
    if (isPositioned(device, "relative", "static", "sticky")(element)) {
        return element.parent(Node.flatTree).filter(isElement);
    }
    else {
        return getOffsetParent(element, device);
    }
}
//# sourceMappingURL=get-positioning-parent.js.map